import { FC, PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';
import { fontWeightNormal } from '@atlas-frontend/design-tokens';
import { Main, Stack, TextSecondary } from '@atlas-frontend/sdk';
import { Button } from 'antd';
import { AppLink } from '../common/AppLink';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './HttpErrorDisplayTemplate.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'http-error-display-template'
);
addTranslations(translations);

export interface HttpErrorDisplayTemplateProps extends PropsWithChildren {
  beforeImage?: ReactNode;
  imgSrc: string;
  title: string;
}

export const HttpErrorDisplayTemplate: FC<HttpErrorDisplayTemplateProps> = (
  props
) => {
  const { beforeImage, imgSrc, title, children } = props;
  const { t } = useTranslation();
  return (
    <Main>
      <Main.Col>
        <ContentWrapper>
          <Stack align="center">
            <ImageWrapper>
              {beforeImage}
              <Img src={imgSrc} alt="error illustration" />
            </ImageWrapper>
            <TextWrapper>
              <NotFoundTitle>{title}</NotFoundTitle>
              <TextSecondary>{children}</TextSecondary>
            </TextWrapper>
            <AppLink id="to-landing-page" to="/">
              {(props) => (
                <Button {...props} type="primary">
                  {t('button')}
                </Button>
              )}
            </AppLink>
          </Stack>
        </ContentWrapper>
      </Main.Col>
    </Main>
  );
};

const Img = styled.img`
  justify-self: center;
  margin-top: -20px;
`;

const ImageWrapper = styled.div`
  display: grid;
`;

const NotFoundTitle = styled.h1`
  margin-bottom: 0 !important;
  font-weight: ${fontWeightNormal};
  font-size: 24px;
  line-height: 32px;
`;

const TextWrapper = styled.div`
  text-align: center;
`;

const ContentWrapper = styled.div`
  display: grid;
  place-items: center;
  height: 100%;
`;
